import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateEditLinkToContainerSaveModel } from 'app/tos-operations/models/CreateEditLinkToContainer.save.model';
import { CreateEditLinkToMotSaveModel } from 'app/tos-operations/models/CreateEditLinkToMot.save.model';
import { CreateEditShipmentPoolSaveModel } from 'app/tos-operations/models/CreateEditShipmentPool.save.model';
import { GetEditDataForLinkContainerModel } from 'app/tos-operations/models/GetEditDataForLinkContainer.save.model';
import { GetEditDataForLinkMotModel } from 'app/tos-operations/models/GetEditDataForLinkMot.save.model';
import { GetMrnWarehouseForLinkMotModel } from 'app/tos-operations/models/GetMrnWarehouseForLinkMot.display.model';
import { GetMrnWarehouseMotNumberForLinkContainerModel } from 'app/tos-operations/models/GetMrnWarehouseMotNumberForLinkContainer.display.model';
import { RenameShipmentPoolSaveModel } from 'app/tos-operations/models/RenameShipmentPoolSaveModel';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ShipmentPoolService {
    constructor(private http: HttpClient) {}

    getShipmentPoolList(filter: any): Observable<any> {
        return this.http.post('api:///ShipmentPool/GetShipmentPoolList', filter);
    }

    getShipmentPool(id: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetShipmentPool/${id}`);
    }

    getCreateServiceRequestContext(shipmentPoolId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetCreateServiceRequestContextForShipmentPool/${shipmentPoolId}`);
    }

    getShipmentPoolSr(shipmentPoolId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetShipmentPoolSr/${shipmentPoolId}`);
    }

    getShipmentPoolListOnServiceRequest(filter: any): Observable<any> {
        return this.http.post(`api:///ShipmentPool/GetShipmentPoolListOnServiceRequest/`, filter);
    }

    createShipmentPool(model: CreateEditShipmentPoolSaveModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/CreateShipmentPool/`, model);
    }

    useShipmentPool(model: CreateEditShipmentPoolSaveModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/UseShipmentPool/`, model);
    }

    editShipmentPoolAndSRVersionShipment(model: CreateEditShipmentPoolSaveModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/EditShipmentPoolAndSRVersionShipment/`, model);
    }

    createShipmentPoolAndLinkToMOT(model: CreateEditShipmentPoolSaveModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/CreateShipmentPoolAndLinkToMOT/`, model);
    }

    useShipmentPoolAndLinkToMOT(model: CreateEditShipmentPoolSaveModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/UseShipmentPoolAndLinkToMOT/`, model);
    }

    getEditDataForShipmentPool(shipmentPoolId: number, serviceRequestId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetEditDataForShipmentPool/${shipmentPoolId}/${serviceRequestId}`);
    }

    getEditDataForShipmentPoolAndSRVersionShipment(serviceRequestVersionShipmentId: number): Observable<any> {
        return this.http.get(
            `api:///ShipmentPool/getEditDataForShipmentPoolAndSRVersionShipment/${serviceRequestVersionShipmentId}`
        );
    }

    getMrnsForCurrentUser(filter: any): Observable<any> {
        return this.http.post(`api:///ShipmentPool/GetMrnsForCurrentUser`, filter);
    }

    getShipmentPoolItemsForShipmentPool(shipmentPoolId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetShipmentPoolItemsForShipmentPool/${shipmentPoolId}`);
    }

    getMrnByMrnString(filter: any): Observable<any> {
        return this.http.post(`api:///ShipmentPool/GetMrnByMrnString`, filter);
    }

    getWarehousesPerSystem(
        serviceRequestTosSystemId: string,
        containsCuswhAdditionalService: boolean
    ): Observable<any> {
        return this.http.get(
            `api:///ServiceRequest/GetWarehousesPerSystemForServiceRequest/${serviceRequestTosSystemId}/${containsCuswhAdditionalService}`
        );
    }

    getAllRequestWarehousesPerSystem(serviceRequestTosSystemId: string): Observable<any> {
        return this.http.get(
            `api:///ServiceRequest/GetAllRequestWarehousesPerSystemForServiceRequest/${serviceRequestTosSystemId}`
        );
    }

    getRequestWarehousesPerSystem(
        serviceRequestTosSystemId: string,
        fromWarehouse: boolean,
        shipmentPoolId: number
    ): Observable<any> {
        return this.http.get(
            `api:///ServiceRequest/GetRequestWarehousesPerSystemForServiceRequest/${serviceRequestTosSystemId}/${fromWarehouse}/${shipmentPoolId}`
        );
    }

    getMarkingsForWarehouseQuery(
        shipmentPoolId: number,
        serviceRequestId: number,
        warehouseId: number,
        fromCustomsStatusId: string = null
    ): Observable<any> {
        return this.http.get(
            `api:///ShipmentPool/GetMarkingsForWarehouseQuery/${shipmentPoolId}/${serviceRequestId}/${warehouseId}/${fromCustomsStatusId}`
        );
    }

    getCustomsWarehouseTypesForShipment(filter: any): Observable<any> {
        return this.http.post(`api:///ShipmentPool/GetCustomsWarehouseTypesForShipment`, filter);
    }

    getFromCustomsStatuses(shipmentPoolId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetFromCustomsStatuses/${shipmentPoolId}`);
    }

    getPreviousMrnsOnShipmentPool(shipmentPoolId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetPreviousMrnsOnShipmentPool/${shipmentPoolId}`);
    }

    getCustomsDeclarationItemsForMrn(mrnId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetCustomsDeclarationItemsForMrn/${mrnId}`);
    }

    getEntryCustomsDeclarationItemsForMrn(mrnId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetEntryCustomsDeclarationItemsForMrn/${mrnId}`);
    }

    getCargoDataForShipmentPool(shipmentPoolId: number): Observable<any> {
        return this.http.get(`api:///ShipmentPool/GetCargoDataForShipmentPool/${shipmentPoolId}`);
    }

    getEditDataForLinkMot(model: GetEditDataForLinkMotModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/GetEditDataForLinkMot/`, model);
    }

    getEditDataForLinkContainer(model: GetEditDataForLinkContainerModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/GetEditDataForLinkContainer/`, model);
    }

    getDataForMrnAndWarehouseOnLinkMot(model: GetMrnWarehouseForLinkMotModel) {
        return this.http.post(`api:///ShipmentPool/GetDataForMrnAndWarehouseOnLinkMot/`, model);
    }

    getCreateAmendmentDocumentDataForShipmentPoolItem(shipmentPoolItemId: number): Observable<any> {
        return this.http.get(
            `api:///AmendmentDocument/GetCreateAmendmentDocumentDataForShipmentPoolItem/${shipmentPoolItemId}`
        );
    }

    getEditAmendmentDocumentData(id: number): Observable<any> {
        return this.http.get(`api:///AmendmentDocument/GetEditAmendmentDocumentData/${id}`);
    }

    createEditLinkToMot(model: CreateEditLinkToMotSaveModel) {
        return this.http.post(`api:///ShipmentPool/CreateEditLinkToMot/`, model);
    }

    createEditLinkToContainer(model: CreateEditLinkToContainerSaveModel) {
        return this.http.post(`api:///ShipmentPool/CreateEditLinkToContainer/`, model);
    }

    getDataForMrnWarehouseMotNumberOnLinkContainer(model: GetMrnWarehouseMotNumberForLinkContainerModel) {
        return this.http.post(`api:///ShipmentPool/GetDataForMrnWarehouseMotNumberOnLinkContainer/`, model);
    }

    closeShipmentPools(data: any): Observable<any> {
        return this.http.post(`api:///ShipmentPool/CloseShipmentPools`, data);
    }

    holdShipmentPools(model: any): Observable<any> {
        return this.http.post(`api:///ShipmentPool/HoldShipmentPools`, model);
    }

    holdShipmentPoolItems(model: any): Observable<any> {
        return this.http.post(`api:///ShipmentPool/HoldShipmentPoolItems`, model);
    }

    renameShipmentPool(model: RenameShipmentPoolSaveModel): Observable<any> {
        return this.http.post(`api:///ShipmentPool/RenameShipmentPool`, model);
    }
}
